import { type StateCreator } from "zustand";

export type LocalePreference = "system" | "en" | "es";
export type ResolvedLocale = "en" | "es";

export interface LocaleState {
  localePreference: LocalePreference;
  resolvedLocale: ResolvedLocale;
}

export interface LocaleActions {
  setLocalePreference: (pref: LocalePreference) => void;
  setResolvedLocale: (locale: ResolvedLocale) => void;
}

export type LocaleSlice = LocaleState & LocaleActions;

export const createLocaleSlice: StateCreator<LocaleSlice, [], [], LocaleSlice> = (set) => ({
  localePreference: "system",
  resolvedLocale: "en",
  setLocalePreference: (pref) => set({ localePreference: pref }),
  setResolvedLocale: (locale) => set({ resolvedLocale: locale }),
});
